import { CAPTION_LANGUAGES } from '@src/constants/caption-languages';

export const formatVersionLabel = (version) => {
  if (!version?.label) return 'Version';
  if (version.label === 'captioned') return 'Captioned';
  return 'Translation';
};

export const getVersionLanguageLabel = (version) => {
  if (!version) return null;
  const code = version.label === 'captioned' ? version.sourceLanguage : (version.targetLanguage || version.label);
  if (!code) return null;
  const lang = CAPTION_LANGUAGES.find((l) => l.code === code);
  return lang ? lang.label : code?.toUpperCase();
};



// WEBPACK FOOTER //
// ./src/helpers/captionVersionHelpers.js